// @ts-check

import React, { Component } from "react"
import { Link } from "react-router"
import { text } from "../../attributes/items/primitives"
import { Text } from "ui"
import ContentEditable from "react-sane-contenteditable"

/**
 * @augments {Component<BlockTypeProps<{text: string}>, any>}
 */
export default class StringBlockType extends Component {
    state = { edits: { edit: null, callback: null } }

    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle, updateAttributes, selected, evaluateFormulas }) => {
                    const linkWrapper = children =>
                        evaluateFormulas(attrs.link).indexOf("://") == -1 ? (
                            <Link to={evaluateFormulas(attrs.link)}>{children}</Link>
                        ) : (
                            <a href={evaluateFormulas(attrs.link)}>{children}</a>
                        )
                    const wrapLink =
                        attrs.link && !this.props.context.editor.isEditing ? linkWrapper : a => a
                    return wrapLink(
                        <ContentEditable
                            tagName={Text}
                            style={computedStyle}
                            content={
                                selected
                                    ? this.state.edit || attrs.text
                                    : evaluateFormulas(this.state.edit || attrs.text)
                            }
                            editable={selected}
                            multiLine={true}
                            styled
                            onChange={(_, value) =>
                                this.saveEditsUntilUnselected(value, updateAttributes)
                            }
                        />
                    )
                }}
            </Wrapper>
        )
    }

    saveEditsUntilUnselected(edit, callback) {
        // Mutate directly so we don't update
        this.state.edits.edit = edit
        this.state.edits.callback = callback
    }

    componentWillUpdate() {
        if (this.state.edits.edit) {
            this.state.edits.callback("text", this.state.edits.edit)
            this.state.edits = { edit: null, callback: null }
        }
    }
}

StringBlockType.attributes = [
    text({ field: "text", label: "Text" }),
    text({ field: "link", label: "Link to page" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/basic/StringBlock.js